import React, { useEffect, useState } from 'react';
import './home.css';
import ProjectSlider from '../../components/ProjectSlider/ProjectSlider';

function Home() {
  const [showTopBtn, setShowTopBtn] = useState(false);
  const [isBottom, setIsBottom] = useState(false);
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    const handleScroll = () => {
      setShowTopBtn(window.scrollY > 400);
      const atBottom =
        window.innerHeight + window.scrollY >= document.body.offsetHeight - 50;
      setIsBottom(atBottom);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const res = await fetch('http://localhost:5000/projects');
        const data = await res.json();
        setProjects(data);
      } catch (err) {
        console.error('Failed to fetch projects:', err);
      }
    };

    fetchProjects();
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="home-container">
      <section className="hero-section">
        <video
          className="background-video"
          autoPlay
          muted
          loop
          playsInline
        >
          <source src="/assets/videolar/Arka_video3.1.mp4" type="video/mp4" />
          Tarayıcınız video etiketini desteklemiyor.
        </video>
        <div className="hero-overlay">
          <h1>ERYA GROUP</h1>
          <strong>HER YAPIDA GÜVEN, HER ÇİZGİDE ÖZEN</strong>
        </div>
      </section>
<section className="about-section"> 
  <div className="about-content-wrapper">
    <div className="about-text">
      <h2>Hakkımızda</h2>
      <p>
        <strong>1998</strong> yılında <strong>Yusuf Çetin</strong>’in hayalleriyle temelleri atılan firmamız, çelik konstrüksiyonun yanı sıra mimari ve dekorasyon alanlarında da güçlü adımlarla ilerleyerek, 2013 yılında <strong>ERYA-GROUP</strong> adıyla kurumsal kimliğine kavuşmuştur. 27 yılı aşkın tecrübemizle, sadece yapılar değil, insanların kendini güvende ve ait hissettiği yaşam alanları inşa etmeyi amaçlıyoruz. Her projemizde kaliteyi, zarafeti ve işlevselliği bir araya getirerek, mühendislikten tasarıma uzanan bir bütünlük sunuyoruz.
        <br /><br />
      Köklü aile geleneğimizi çağdaş bir vizyonla harmanlayarak, hem yurt içinde hem de yurt dışında saygın projelere imza atıyoruz. Mimari dokunuşlarımızla estetik değerleri ön plana çıkarıyor, dekorasyon çözümlerimizle mekanlara ruh katıyoruz. <strong>ERYA-GROUP</strong> olarak, çeliğin sağlamlığını, tasarımın zarafetini ve dekorasyonun sıcaklığını bir araya getirerek, geleceği şekillendiren yapılar üretmeye tutkuyla devam ediyoruz.
      </p>
    </div>
    <div className="about-video">
      
      <video
        src="/assets/videolar/WhatsApp%20Video%202025-06-30%20at%2019.38.28.mp4"
        autoPlay
        muted
        loop
        playsInline
        className="video-element"
      />
    </div>
  </div>
</section>


      <section className="projects-section">
        <h2>Projelerimiz</h2>
        <ProjectSlider projects={projects} />
      </section>

      <section className="contact-form-section">
        <h2>İletişim</h2>
        <form
          action="https://formsubmit.co/info@erya-group.com"
          method="POST"
          className="contact-form"
        >
          <input type="text" name="name" placeholder="Adınız" required />
          <input type="email" name="email" placeholder="Email" required />
          <textarea name="message" placeholder="Mesajınız" required></textarea>
          <button type="submit" >Gönder</button>
        </form>

        <div className="map-container">
          <h2>Biz Neredeyiz?</h2>
          <iframe
            title="Client Location"
           src="https://www.google.com/maps/place/Google+İstanbul/@41.0816306,29.0098542,17z/data=!3m1!4b1!4m6!3m5!1s0x14cab66669fcd281:0x68f47ef200169cd0!8m2!3d41.0816306!4d29.0098542!16s%2Fg%2F1td_340s3"
            height="300"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </section>

      {showTopBtn && (
        <button
          className={`back-to-top ${isBottom ? 'scrolled-bottom' : ''}`}
          onClick={scrollToTop}
          aria-label="Back to top"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="feather feather-chevron-up"
          >
            <polyline points="18 15 12 9 6 15" />
          </svg>
        </button>
      )}
    </div>
  );
}

export default Home;
